export default "https://cdn.questicon.mathletics.com/assets/audio/AYR_Completion-a7ba0f4f21725145a11ff86cb296dd44.mp3";